<template>
    <v-tooltip bottom :content-class="contentClass" v-bind="$attrs" v-on="$listeners">
        <template #activator="{ on }">
            <slot name="activator" v-bind="{ on }"></slot>
        </template>
        <slot></slot>
    </v-tooltip>
</template>

<script>
/**
 * Wrapper around standart v-tooltip: defines default content class so that
 * all tool tips look the same.
 *
 * slots: Same as v-tooltip:
 * - default: component inside alert
 * - activator: button/component to activate tooltip
 */
export default {
    name: 'KpTooltip',
    props: {
        contentClass: {
            type: String,
            default: 'tooltip-default',
        },
    },
};
</script>

<style lang="scss" scoped>
.tooltip-default.v-tooltip__content {
    font-size: 1rem;
    line-height: calc(1.2 * 1rem);
    background-color: var(--panel-bg-color);
    opacity: 0.97;
    color: var(--nearblack-color);
    border: 1px solid var(--tgk-grey);
    border-radius: 3px;
    box-shadow: 2px 2px 8px rgba(88, 88, 88, 0.3);
    max-width: 600px;
    padding: 10px;

    :deep(p:last-child) {
        margin-bottom: 0;
    }
}
</style>
